const HISTORY_PREFIX = 'Module.History';

export const HISTORY_FEATURES = {
  module: `${HISTORY_PREFIX}`,
};
